module.exports = __webpack_public_path__ + "img/16.e07588b4.png";